export type CarrierIconData = {
    path: string;
    height?: string;
};
const iconPath = (file: string) => `/assets/carrier-icons/${file}`;
export const carrierIcons: Record<string, CarrierIconData> = {
    "click-and-collect": { path: iconPath("click-and-collect.svg") },
    dhl: { path: iconPath("dhl.svg") },
    dhl_parcel_europe: { path: iconPath("dhl.svg") },
    dhl_express: { path: iconPath("dhl.svg") },
    gls: { path: iconPath("gls.svg") },
    inpost_pl: { path: iconPath("in_post.svg") },
    omniva: { path: iconPath("omniva.svg") },
    dpd_at: { path: iconPath("dpd.svg") },
    postnord_dk: { path: iconPath("postnord.svg") },
    ninja_van: { path: iconPath("ninjavan.svg") },
    parcelforce: { path: iconPath("parcelforce.jpg") },
    canada_post: { path: iconPath("ca_post.png") },
    australia_post: { path: iconPath("au_post.png") },
    australia_post_express: { path: iconPath("au_post.png") },
    shiprocket: { path: iconPath("shiprocket.png") },
    lotte: { path: iconPath("lotte.png") },
    swiss_post: { path: iconPath("swiss_post.png") },
    magyar_posta: { path: iconPath("magyar_posta.png") },
    ups: { path: iconPath("ups.png") },
    fedex: { path: iconPath("fedex.png") },
    anpost: { path: iconPath("an_post.png") },
    multipleIcons: { path: iconPath("multipleIcons.svg"), height: "30px" },
    posti: { path: iconPath("posti.png") },
    royal_mail: { path: iconPath("royal_mail.svg") },
    nz_post: { path: iconPath("nz_post.png") },
    gap: { path: iconPath("gap-akis-express.webp") },
    ctt: { path: iconPath("ctt.svg") },
    /*
		JP market needs to confirm the icons to use for these carriers, so commenting them out for now to avoid drama.
		japan_post: {
			path: iconPath("jp_post.png"),
		},
		yamato_transport: {
			path: iconPath("yamato_transport.svg"),
		},
	*/
    fallback: {
        path: iconPath("fallback.svg"),
        height: "30px",
    },
};
